import { api } from './client'

/** R5-06 (D-13b, REQ-288-001): client di `AnnualArchiveController`. Solo Admin, dietro il flag `privacy.archivio_annuale`. */
export const ANNUAL_ARCHIVE_FLAG = 'privacy.archivio_annuale'

export interface AnnualArchiveCategory { category: string; rows: number }

export interface AnnualArchiveRow {
  year: number
  status: 'in_coda' | 'in_corso' | 'pronto' | 'errore'
  jobId: number | null
  fileName: string | null
  sizeBytes: number | null
  sha256: string | null
  totalRows: number | null
  error: string | null
  requestedAt: string | null
  generatedAt: string | null
}

export interface AnnualArchiveYear {
  year: number
  totalRows: number
  categories: AnnualArchiveCategory[]
  archive: AnnualArchiveRow | null
}

export interface AnnualArchiveDownload {
  id: number
  year: number
  sha256: string | null
  downloadedBy: number | null
  downloadedByName: string | null
  downloadedAt: string
}

export const annualArchiveApi = {
  list: () => api<{ items: AnnualArchiveYear[] }>('/api/annual-archive'),
  generate: (year: number) => api<{ queued: boolean; jobId: number; message: string }>(`/api/annual-archive/${year}/generate`, { method: 'POST' }),
  downloads: (year?: number) => api<{ items: AnnualArchiveDownload[] }>(`/api/annual-archive/downloads${year ? `?year=${year}` : ''}`),
  downloadUrl: (year: number) => `/api/annual-archive/${year}/download`,
}
